module.exports = __webpack_public_path__ + "static/img/ls47.2b21b30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls47.png
// module id = DO4I
// module chunks = 12